const driverHu = {
	driverTable: 'Driver',
	driverEditForm: 'Driver',
	name: 'Név',
	code: 'Kód',
	created: 'Létrehozva',
	updated: 'Módosítva',
	type: 'Model type',
	driverLog: 'Driver log',
	endpoint: 'Endpoint',
};

export default driverHu;
